import { observer } from 'mobx-react';
import * as React from 'react';
import ExternalMenuItem from '../ExternalMenuItem';
import { findLink } from '../../../../../LinkyLinky';
import { currentUserStore } from '../../../../../CurrentUserStore';

const SupportLink: React.FC = () =>
  findLink('support', currentUserStore.links)
    .map(({ href }) => (
      <ExternalMenuItem
        actionType="new-tab"
        key="support"
        menuItemContent={{
          content: 'Support',
          to: href,
          rel: 'support',
        }}
      />
    ))
    .getOrElseValue(<></>);

export default observer(SupportLink);
